import React from 'react'
import '../../styles/GetAShareStyles/getashare.css'
import Factory from './Factory'
export default class GetAShare extends React.Component{
    render(){
        return(
            <section className="gas__container" id='get-a-share-anchor'>
                <div className="gas__factory">
                    <Factory />
                </div>
                <div className="gas__information-text">
                    <h1 className="gas__title title">
                        Get a share of the transaction fees
                    </h1>
                    <div className="gas__text text">
                        Our transaction fees are distributed amongst Kronn Coin
                        holders proportional to the number of coins in posession
                        and time spent dormant in your wallet. Exchange fees in other
                        currencies are converted to Kronn for distribution by a
                        trading bot to ensure maximum profits. <br/><br/>
                        Distribution is done in Kronn Coins ensuring that
                        the distribution of shares is fair, and the information
                        on the ledger hasn’t been tampered with.
                        The share distribution model incentivizes lower
                        supply of coins as people will want to keep the coin for
                        longer periods of time and the automatic purchase of Kronn
                        coins with different currencies to distribute transaction
                        fees will help fuel the growth of the coin
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/GetAShare/GetAShare.js